// Feature flag for the public self-service reschedule/cancel page (issue #149).
//
// The public EXECUTION path (an anonymous ClientApplication / server proxy that lets a patient with no
// Medplum session invoke the verifying bot) is tracked in #166, and transactional slot
// reservation+rollback in the kernel is tracked in #167. Until #166 lands we must NOT ship a working-
// looking public link, so the `/reschedule` route is gated behind this flag, which is OFF by default.
// The page component and the server-side verifying bot stay in the build so #166 can flip this on.

/** True only when `VITE_ENABLE_SELF_RESCHEDULE` is explicitly `"true"`. Off for every other value. */
export function isSelfRescheduleEnabled(env: { VITE_ENABLE_SELF_RESCHEDULE?: string } = import.meta.env): boolean {
  return env.VITE_ENABLE_SELF_RESCHEDULE === 'true';
}
